import { Controller } from "@hotwired/stimulus"

import { copyText } from "@/lib/clipboard"

// Spotify-style 3-dot menu on tracklist rows / item pages: Add to
// collection (swaps the popover to the collection picker) and Share
// (copies the item URL). The kebab gets a soft purple highlight while
// the menu is open; closing resets everything.
export default class extends Controller {
  static targets = ["kebab", "actions", "picker", "popover", "copied"]
  static values = { url: String }

  declare readonly kebabTarget: HTMLElement
  declare readonly actionsTarget: HTMLElement
  declare readonly pickerTarget: HTMLElement
  declare readonly popoverTarget: HTMLElement & { hidePopover(): void }
  declare readonly copiedTarget: HTMLElement
  declare readonly urlValue: string
  private copiedTimer: number | undefined

  toggled(event: Event) {
    const open = (event as ToggleEvent).newState === "open"
    this.kebabTarget.dataset.open = open ? "true" : "false"
    if (!open) this.reset()
  }

  showPicker(event: Event) {
    // Keep the popover open — the click must not bubble into light-dismiss
    // or row-level handlers.
    event.stopPropagation()
    this.actionsTarget.classList.add("hidden")
    this.pickerTarget.classList.remove("hidden")
  }

  share(event: Event) {
    event.stopPropagation()
    void copyText(this.urlValue)
    // Close the menu and confirm with a transient chip by the kebab —
    // sturdier than in-menu feedback, since the copy fallback's focus
    // shuffle can light-dismiss the popover anyway.
    this.popoverTarget.hidePopover()
    this.copiedTarget.classList.remove("hidden")
    window.clearTimeout(this.copiedTimer)
    this.copiedTimer = window.setTimeout(
      () => this.copiedTarget.classList.add("hidden"),
      1600,
    )
  }

  private reset() {
    this.actionsTarget.classList.remove("hidden")
    this.pickerTarget.classList.add("hidden")
  }
}
